<div [dir]="dialogData.dir || 'rtl'">
	<mat-dialog-content>
		<p>{{ dialogData.message | translate }}</p>
	</mat-dialog-content>
	<div class="d-flex justify-content-end">
		<button *ngIf="dialogData.buttonText.ok" [mat-dialog-close]="true" mat-button color="warn" class="mx-2">
			{{ dialogData.buttonText.ok | translate }}
		</button>
		<button *ngIf="dialogData.buttonText.cancel" mat-button mat-dialog-close>
			{{ dialogData.buttonText.cancel | translate }}
		</button>
	</div>
</div>